// components/main/ObjekteListeForm.jsx
import "./ObjekteListeForm.css";
import React from "react";
import { useState } from "react";
import { setFilter } from "../redux/filterState";
import { Range } from "react-range";
import ObjektBild from '../utils/ObjektBild.jsx';
import ObjektKeyInfo from '../utils/ObjektKeyInfo.jsx';
import { FaSave, FaFolderOpen } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import FilterModal from '../utils/FilterModal.jsx';

const ObjekteListeForm = ({
  objekte,
  getSortStyle,
  getSortSymbol,

  getLandName,
  getWaehrungName,
  getMaterialName,

  toggleSort,
  handleLinkClick,

  kategorien,
  ablageorte,
  typen,
  laender,
  materialien,
  waehrungen,
  zustaende,
  eigentuemerdata,

  filters,
  dispatch,
  resetFilter,
  onPageChange,   // pagination

  toggleImage,
  activeImage,
  toggleView,
  activeView,

  // loadFilter,    old version
  // saveFilter,    old version
  // deleteFilter,  old version
  onLoadFilter,
  onSaveFilter,
  onDeleteFilter
}) => {

  // load redux store
  const anyFilterActive = typeof filters === "object" && filters !== null
    ? Object.values(filters).some(val => val !== "")
    : false;

  // control open/close accordion
  const [isOpen, setIsOpen] = useState(false);

  // limit pagination tabs to max. 10 (pagination with ellipses)
  function getVisiblePages(current, total) {
    const maxVisible = 10;

    if (total <= maxVisible) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const visible = [];

    if (current <= 5) {
      visible.push(...[1, 2, 3, 4, 5, 6, null, total]);
    } else if (current >= total - 4) {
      visible.push(1, null, ...Array.from({ length: 6 }, (_, i) => total - 6 + i + 1));
    } else {
      visible.push(1, null, current - 1, current, current + 1, null, total);
    }
    return visible;
  }

  const pages = getVisiblePages(filters.currentPage, filters.totalPages);

  // proceed date range values
  const min = filters.jahrgangRangeMin;
  const max = filters.jahrgangRangeMax;

  const parsedMin = parseInt(filters.jahrgangMin);
  const parsedMax = parseInt(filters.jahrgangMax);

  const currentMin = !isNaN(parsedMin) && parsedMin >= min ? parsedMin : min;
  const currentMax = !isNaN(parsedMax) && parsedMax <= max ? parsedMax : max;

  // dropdown labels array
  const filterDefinitions = [
      { label: "Kategorien", key: "kategorie", options: kategorien },  
      { label: "Währungen", key: "waehrung", options: waehrungen },
      { label: "Länder", key: "land", options: laender },
      { label: "Typen", key: "typ", options: typen },
      { label: "Materialien", key: "material", options: materialien },
      { label: "Zustände", key: "zustand", options: zustaende },
      { label: "Ablageorte", key: "ablageort", options: ablageorte },
      { label: "Eigentümer", key: "eigentuemer", options: eigentuemerdata }
  ];

  // check label text: 'Eigentümer' can have name and/or vorname, all other categories only have name
  const getLabel = (found) => {
    if (!found) return null;

    const vor = found.vorname?.trim();
    const nach = found.name?.trim();

    if (vor && nach) return `${vor} ${nach}`;
    if (vor) return vor;
    if (nach) return nach;

    return null;
  };

  // get active label 
  const getActiveFilterLabels = () => {
    const active = [];

    filterDefinitions.forEach(({ key, options }) => {
      const value = filters[key];
      if (!value) return;

      const found = options.find(o => o.id == value); // absichtlicher == Vergleich
      if (!found) return;

      const label = getLabel(found);
      if (label) active.push(label);

    });

    // check date range selector
    if ((filters.jahrgangMin != filters.jahrgangRangeMin) || (filters.jahrgangMax != filters.jahrgangRangeMax)) {

        const min = filters.jahrgangMin;
        const max = filters.jahrgangMax;
        
        if (min && max) {
          active.push(`${min}–${max}`);
        }
    }

    return active;
  };

  // helper function: 3 items max
  const formatActiveText = (labels) => {
    if (labels.length === 0) return "";

    const max = 3;
    const shown = labels.slice(0, max).join(", ");

    return labels.length > max
      ? ` (aktiv: ${shown}, …)`
      : ` (aktiv: ${shown})`;
  };

  const activeLabels = getActiveFilterLabels();
  const activeText = formatActiveText(activeLabels);

  return (
    <div className="container mt-4">
      {/* Accordion for filter block */}
      <div className="accordion mb-4" id="filterAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="filterHeading">
            <button
              className={`accordion-button ${isOpen ? "" : "collapsed"}`}
              type="button"
              onClick={() => setIsOpen(!isOpen)}
            >
              Filter anzeigen
              {activeText && (
                <span className="active-filter-text">{activeText}</span>
              )}
            </button>
          </h2>
          <div
            id="filterCollapse"
            className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
          >
            <div className="accordion-body">
              <div className="row g-3">

                {filterDefinitions.map(({ label, key, options }) => (
                  <div className="col-md-3" key={key}>
                    <select
                      className="form-select"
                      value={filters[key]}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (filters[key] !== newValue) {
                          dispatch(setFilter(key, newValue));
                        }
                      }}
                    >
                      <option value="">Alle {label}</option>

                      {options.map(o => (
                        <option key={o.id} value={o.id}>
                          {getLabel(o)}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}

                {/* year range slider */}
                {filters.jahrgangRangeMin < filters.jahrgangRangeMax && (
                  <div className="col-12 mt-3">
                    <label className="form-label">Jahrgangsbereich</label>
                    <Range
                      step={1}
                      min={min}
                      max={max}
                      values={[currentMin, currentMax]}
                      onChange={([newMin, newMax]) => {
                        const minStr = newMin.toString();
                        const maxStr = newMax.toString();

                        if (filters.jahrgangMin !== minStr) {
                          dispatch(setFilter("jahrgangMin", minStr));
                        }
                        if (filters.jahrgangMax !== maxStr) {
                          dispatch(setFilter("jahrgangMax", maxStr));
                        }
                      }}

                      renderTrack={({ props, children }) => (
                        <div
                          {...props}
                          style={{
                            ...props.style,
                            height: "6px",
                            background: "#ccc",
                            borderRadius: "3px",
                            margin: "10px 0"
                          }}
                        >
                          {children}
                        </div>
                      )}
                      renderThumb={({ props }) => {
                        const { key, ...rest } = props; // remove 'key' from props
                        return(
                          <div
                            key={key}
                            {...rest}
                            style={{
                              ...props.style,
                              height: "20px",
                              width: "20px",
                              backgroundColor: "#007bff",
                              borderRadius: "50%"
                            }}
                          />
                        );
                      }}
                    />
                    <div className="d-flex justify-content-between small">
                      <span>{filters.jahrgangMin || filters.jahrgangRangeMin}</span>
                      <span>{filters.jahrgangMax || filters.jahrgangRangeMax}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* buttons inside accordion */}
              <div className="mt-3 d-flex justify-content-between align-items-center">

                {/* left side */}
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={onLoadFilter}
                    title="Filter laden"
                  >
                    <FaFolderOpen />
                  </button>

                  <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={onSaveFilter}
                    title="Filter speichern"
                  >
                    <FaSave />
                  </button>

                  <button
                    // className="btn btn-danger ms-auto"
                    className="btn btn-secondary"
                    type="button"
                    onClick={onDeleteFilter}
                    title="Filter löschen"
                  >
                    <MdDelete />
                  </button>

                </div>

                {/* right side */}
                <button
                  className="btn btn-outline-secondary"
                  onClick={resetFilter}
                >
                  Filter zurücksetzen
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main object list */}
      {objekte.length === 0 ? (
        <div className="alert alert-info">Keine Objekte vorhanden.</div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="d-none d-sm-table-cell" onClick={() => toggleSort("id")} style={getSortStyle("id")}>Nr.{getSortSymbol("id")}</th>
                  <th className="d-none d-sm-table-cell" onClick={() => toggleSort("nominalwert")} style={getSortStyle("nominalwert")}>Wert{getSortSymbol("nominalwert")}</th>
                  <th className="d-none d-md-table-cell" onClick={() => toggleSort("sammlerwert")} style={getSortStyle("sammlerwert")}>Sammlerwert{getSortSymbol("sammlerwert")}</th>
                  <th className="d-none d-sm-table-cell" onClick={() => toggleSort("waehrung")} style={getSortStyle("waehrung")}>Währung{getSortSymbol("waehrung")}</th>
                  <th className="d-none d-sm-table-cell" onClick={() => toggleSort("land")} style={getSortStyle("land")}>Land{getSortSymbol("land")}</th>
                  <th className="d-none d-sm-table-cell" onClick={() => toggleSort("jahrgang")} style={getSortStyle("jahrgang")}>Jahrgang{getSortSymbol("jahrgang")}</th>
                  <th className="d-none d-md-table-cell" className="d-none d-md-table-cell" onClick={() => toggleSort("material")} style={getSortStyle("material")}>Material{getSortSymbol("material")}</th>
                  <th className="d-none d-md-table-cell" onClick={() => toggleSort("anzahl")} style={getSortStyle("anzahl")}>Anzahl{getSortSymbol("anzahl")}</th>
                  <th className="d-none d-md-table-cell" style={getSortStyle("bild")}>Bilder{getSortSymbol("bild")}</th>
                  <th className="d-sm-none" style={getSortStyle("bild")}>Objekte{getSortSymbol("bild")}</th>
                </tr>
              </thead>
              
              <tbody>
                {objekte.map((o) => {
                  // Compute available views for this row
                  const views = [];
                  if (o.bild01) views.push("bild01");
                  if (o.bild02) views.push("bild02");
                  views.push("info");

                  return (
                    <tr key={o.id}>
                      <td className="d-none d-sm-table-cell">
                        <button
                          className="btn btn-link text-decoration-underline p-0"
                          onClick={() => handleLinkClick(o.id)}
                        >
                          {o.id}
                        </button>
                      </td>

                      <td className="d-none d-sm-table-cell">{o.nominalwert}</td>
                      <td className="d-none d-md-table-cell">{o.sammlerwert}</td>
                      <td className="d-none d-sm-table-cell">{getWaehrungName(o.waehrung)}</td>
                      <td className="d-none d-sm-table-cell">{getLandName(o.land)}</td>
                      <td className="d-none d-sm-table-cell">{o.jahrgang}</td>
                      <td className="d-none d-md-table-cell">{getMaterialName(o.material)}</td>
                      <td className="d-none d-md-table-cell">{o.anzahl}</td>
                      <td className="d-none d-md-table-cell">
                        <ObjektBild
                          coin={o}
                          activeImage={activeImage}
                          onToggle={() => toggleImage(o.id, o)}
                          showImageMarker={true}
                          isMobile={false}
                        />
                      </td>
                      <td className="d-sm-none text-center align-middle objekt-cell">
                        {(() => {
                          const view =
                            activeView[o.id] ||
                            (o.bild01 ? "bild01" : o.bild02 ? "bild02" : "info");

                          if (view === "info") {
                            return (
                              <ObjektKeyInfo
                                id={o.id}
                                nominalValue={o.nominalwert}
                                currencyName={getWaehrungName(o.waehrung)}
                                year={o.jahrgang}
                                countryName={getLandName(o.land)}
                                onClick={(id, isLink) => {
                                  if (isLink) handleLinkClick(id);
                                  else toggleView(o.id, o);
                                }}
                              />
                            );
                          }

                          return (
                            <ObjektBild
                              coin={o}
                              activeImage={view}
                              onToggle={() => toggleView(o.id, o)}
                              onDetailClick={handleLinkClick}
                              showDetailButton={true}
                              showImageMarker={true}
                              isMobile={true}
                            />
                          );
                        })()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="Seitenwahl">
            <ul className="pagination justify-content-center">
              <li className={`page-item ${filters.currentPage === 1 ? "disabled" : ""}`}>
                <a href="#" className="page-link" onClick={() => onPageChange(filters.currentPage - 1)}>«</a>
              </li>

              {pages.map((page, idx) =>
                page === null ? (
                  <li key={`ellipsis-${idx}`} className="page-item disabled">
                    <span className="page-link">…</span>
                  </li>
                ) : (
                  <li key={page} className={`page-item ${Number(filters.currentPage) === Number(page) ? "active" : ""}`}>
                    <a href="#" className="page-link" onClick={() => onPageChange(page)}>{page}</a>
                  </li>
                )
              )}

              <li className={`page-item ${filters.currentPage === filters.totalPages ? "disabled" : ""}`}>
                <a href="#" className="page-link" onClick={() => onPageChange(filters.currentPage + 1)}>»</a>
              </li>
            </ul>
          </nav>
        </>
      )}

    </div>
  );
};

export default ObjekteListeForm;
